export enum UserListSortOptions {
    NameASC = "NameAsc",
    NameDESC = "NameDesc",
    EmailASC = "EmailAsc",
    EmailDESC = "EmailDesc",
    RoleASC = "MostPermissiveRoleAsc",
    RoleDESC = "MostPermissiveRoleDesc",
    StatusASC = "StatusAsc",
    StatusDESC = "StatusDesc",
    OrganizationASC = "OrganizationAsc",
    OrganizationDESC = "OrganizationDesc",
    LastLoginASC = "LastLoginAsc",
    LastLoginDESC = "LastLoginDesc",
    InvitationStatusASC = "InvitationStatusAsc",
    InvitationStatusDESC = "InvitationStatusDesc",
}

export enum OrganizationListSortOptions {
    OrganizationNameASC = "NameAsc",
    OrganizationNameDESC = "NameDesc",
    OwnerASC = "OwnerAsc",
    OwnerDESC = "OwnerDesc",
    BillingStatusASC = "BillingStatusAsc",
    BillingStatusDESC = "BillingStatusDesc",
    OrganizationStatusASC = "OrganizationStatusAsc",
    OrganizationStatusDESC = "OrganizationStatusDesc",
    PricingTierASC = "PricingTierAsc",
    PricingTierDESC = "PricingTierDesc",
    MemberCountASC = "MemberCountAsc",
    MemberCountDESC = "MemberCountDesc",
}

export enum MemberListSortOptions {
    NameASC = "NameAsc",
    NameDESC = "NameDesc",
    EmailASC = "EmailAsc",
    EmailDESC = "EmailDesc",
    StatusASC = "StatusAsc",
    StatusDESC = "StatusDesc",
    LastLoginASC = "LastLoginAsc",
    LastLoginDESC = "LastLoginDesc",
    PhoneNumberASC = "PhoneAsc",
    PhoneNumberDESC = "PhoneDesc",
    InvitationStatusASC = "InvitationStatusAsc",
    InvitationStatusDESC = "InvitationStatusDesc",
    MostPermissiveRoleASC = "MostPermissiveRoleAsc",
    MostPermissiveRoleDESC = "MostPermissiveRoleDesc",
}

export enum PropertyListSortOptions {
    AddressASC = "AddressAsc",
    AddressDESC = "AddressDesc",
    TitleASC = "TitleAsc",
    TitleDESC = "TitleDesc",
    LotNumberASC = "LotNumberAsc",
    LotNumberDESC = "LotNumberDesc",
    MemberCountASC = "MemberCountAsc",
    MemberCountDESC = "MemberCountDesc",
    StatusASC = "StatusAsc",
    StatusDESC = "StatusDesc",
}

export enum CountryListSortOptions {
    NameAsc = "NameAsc", 
    NameDesc = "NameDesc", 
    Alpha2CodeAsc = "Alpha2CodeAsc", 
    Alpha2CodeDesc = "Alpha2CodeDesc", 
    Alpha3CodeAsc = "Alpha3CodeAsc", 
    Alpha3CodeDesc = "Alpha3CodeDesc", 
    NumericCodeAsc = "NumericCodeAsc", 
    NumericCodeDesc = "NumericCodeDesc"
}

export enum StateProvinceListSortOptions {
    NameAsc = "NameAsc", 
    NameDesc = "NameDesc", 
    AbbreviationAsc = "AbbreviationAsc", 
    AbbreviationDesc = "AbbreviationDesc"
}

export enum PropertyChargeScheduleListSortOptions {
    NameAsc = "NameAsc", 
    NameDesc = "NameDesc", 
    PropertyCountAsc = "PropertyCountAsc", 
    PropertyCountDesc = "PropertyCountDesc", 
    ScheduledAmountAsc = "ScheduledAmountAsc", 
    ScheduledAmountDesc = "ScheduledAmountDesc", 
    FrequencyAsc = "FrequencyAsc", 
    FrequencyDesc = "FrequencyDesc", 
    LateChargesAsc = "LateChargesAsc", 
    LateChargesDesc = "LateChargesDesc", 
    LastModifiedAsc = "LastModifiedAsc", 
    LastModifiedDesc = "LastModifiedDesc", 
    StatusAsc = "StatusAsc", 
    StatusDesc = "StatusDesc"
}

export enum PropertyChargeListSortOptions {
    PropertyChargeIdAsc = "PropertyChargeIdAsc",
    PropertyChargeIdDesc = "PropertyChargeIdDesc",
    PropertyTitleAsc = "PropertyTitleAsc",
    PropertyTitleDesc = "PropertyTitleDesc",
    PrimaryAddressAsc = "PrimaryAddressAsc",
    PrimaryAddressDesc = "PrimaryAddressDesc",
    LotNumberAsc = "LotNumberAsc",
    LotNumberDesc = "LotNumberDesc",
    IssuedAsc = "IssuedAsc",
    IssuedDesc = "IssuedDesc",
    DueAsc = "DueAsc",
    DueDesc = "DueDesc",
    StatusAsc = "StatusAsc",
    StatusDesc = "StatusDesc",
    OwedAmountAsc = "OwedAmountAsc",
    OwedAmountDesc = "OwedAmountDesc",
    PaidAmountAsc = "PaidAmountAsc",
    PaidAmountDesc = "PaidAmountDesc",
    PaidDateAsc = "PaidDateAsc",
    PaidDateDesc = "PaidDateDesc",
    LateFeesAsc = "LateFeesAsc",
    LateFeesDesc = "LateFeesDesc",
    NameAsc = "NameAsc",
    NameDesc = "NameDesc"
}

export enum PaymentHistoryListSortOptions {
    StatusAsc = "StatusAsc",
    StatusDesc = "StatusDesc",
    DatePaidAsc = "DatePaidAsc",
    DatePaidDesc = "DatePaidDesc",
    DueDateAsc = "DueDateAsc",
    DueDateDesc = "DueDateDesc",
    AmountAsc = "AmountAsc",
    AmountDesc = "AmountDesc",
    FeesAsc = "FeesAsc",
    FeesDesc = "FeesDesc"
}

export enum ExpenseListSortOptions {
    VendorNameAsc = "VendorNameAsc",
    VendorNameDesc = "VendorNameDesc",
    ReferenceNumberAsc = "ReferenceNumberAsc",
    ReferenceNumberDesc = "ReferenceNumberDesc",
    ExpenseAccountAsc = "ExpenseAccountAsc",
    ExpenseAccountDesc = "ExpenseAccountDesc",
    AmountAsc = "AmountAsc",
    AmountDesc = "AmountDesc",
    DatePaidAsc = "DatePaidAsc",
    DatePaidDesc = "DatePaidDesc",
    StatusAsc = "StatusAsc",
    StatusDesc = "StatusDesc"
}

export enum DocumentListSortOptions {
    NameAsc = "NameAsc",
    NameDesc = "NameDesc",
    LastModifiedAsc = "LastModifiedAsc",
    LastModifiedDesc = "LastModifiedDesc",
    SizeAsc = "SizeAsc",
    SizeDesc = "SizeDesc",
    TypeAsc = "TypeAsc",
    TypeDesc = "TypeDesc"
}

/** Sort options accepted by POST /folders/filter — matches the API's FolderSortOptions. */
export enum FolderSortOptions {
    NameAsc = "NameAsc",
    NameDesc = "NameDesc",
    CreatedAsc = "CreatedAsc",
    CreatedDesc = "CreatedDesc",
    LastModifiedAsc = "LastModifiedAsc",
    LastModifiedDesc = "LastModifiedDesc"
}

/** Sort options accepted by POST /documents/filter — matches the API's DocumentSortOptions. */
export enum DocumentSortOptions {
    NameAsc = "NameAsc",
    NameDesc = "NameDesc",
    CreatedAsc = "CreatedAsc",
    CreatedDesc = "CreatedDesc",
    LastModifiedAsc = "LastModifiedAsc",
    LastModifiedDesc = "LastModifiedDesc",
    SizeAsc = "SizeAsc",
    SizeDesc = "SizeDesc",
    TypeAsc = "TypeAsc",
    TypeDesc = "TypeDesc"
}

export enum SentEmailSortOptions {
    SentAtDesc = "SentAtDesc",
    SentAtAsc = "SentAtAsc",
    RecipientAsc = "RecipientAsc",
    RecipientDesc = "RecipientDesc",
    SubjectAsc = "SubjectAsc",
    SubjectDesc = "SubjectDesc",
    StatusAsc = "StatusAsc",
    StatusDesc = "StatusDesc",
    EmailTypeAsc = "EmailTypeAsc",
    EmailTypeDesc = "EmailTypeDesc"
}

export enum BankTransactionSortOptions {
    TransactedAtDesc = "TransactedAtDesc",
    TransactedAtAsc = "TransactedAtAsc",
    AmountAsc = "AmountAsc",
    AmountDesc = "AmountDesc",
    DescriptionAsc = "DescriptionAsc",
    DescriptionDesc = "DescriptionDesc",
    /** When a transaction was reconciled. Open transactions carry no cleared date, so they sort last. */
    ClearedAtAsc = "ClearedAtAsc",
    ClearedAtDesc = "ClearedAtDesc"
}

export enum BankConnectionSortOptions {
    InstitutionNameAsc = "InstitutionNameAsc",
    InstitutionNameDesc = "InstitutionNameDesc",
    LastModifiedAsc = "LastModifiedAsc",
    LastModifiedDesc = "LastModifiedDesc",
    StatusAsc = "StatusAsc",
    StatusDesc = "StatusDesc"
}

export enum ChartOfAccountListSortOptions {
    AccountNumberAsc = "AccountNumberAsc",
    AccountNumberDesc = "AccountNumberDesc",
    NameAsc = "NameAsc",
    NameDesc = "NameDesc",
    CategoryAsc = "CategoryAsc",
    CategoryDesc = "CategoryDesc",
    StatusAsc = "StatusAsc",
    StatusDesc = "StatusDesc"
}

export enum BudgetListSortOptions {
    NameAsc = "NameAsc",
    NameDesc = "NameDesc",
    YearAsc = "YearAsc",
    YearDesc = "YearDesc",
    StatusAsc = "StatusAsc",
    StatusDesc = "StatusDesc",
    LastModifiedAsc = "LastModifiedAsc",
    LastModifiedDesc = "LastModifiedDesc",
    FrequencyAsc = "FrequencyAsc",
    FrequencyDesc = "FrequencyDesc"
}

export enum FeatureFlagSortOptions {
    KeyAsc = "KeyAsc",
    KeyDesc = "KeyDesc",
    LastModifiedAsc = "LastModifiedAsc",
    LastModifiedDesc = "LastModifiedDesc"
}

export enum FeatureFlagOverrideSortOptions {
    OrganizationNameAsc = "OrganizationNameAsc",
    OrganizationNameDesc = "OrganizationNameDesc",
    FeatureFlagKeyAsc = "FeatureFlagKeyAsc",
    FeatureFlagKeyDesc = "FeatureFlagKeyDesc",
    LastModifiedAsc = "LastModifiedAsc",
    LastModifiedDesc = "LastModifiedDesc"
}
